import type { Ref } from 'vue';
import { watch } from 'vue';

import type { HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';

import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class InternalReferralProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    super.realtimeBranchModifications({ formDefinition });

    const businessUnit = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.businessUnit,
    });
    const referrerEmail = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.email,
    });

    const utmSource = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.utmSource,
    });

    const utmMedium = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.utmMedium,
    });

    watch([businessUnit, referrerEmail], ([bu, email]) => {
      utmSource.val = `Referred by: ${email} - ${bu}`;
      utmMedium.val = 'Referral';
    });
  }
}
